@if (control.errors && control.errors.notifications) {
  <div
    class="error-control-wrapper"
  [style]="{
    'margin-top': offsetValue + 'px',
    'margin-bottom': -offsetValue + 'px'
  }">
    @for (item of control.errors.notifications; track item) {
      <span>{{ item }}</span>
    }
  </div>
}
